var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowOutOfSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9165 2C9.9165 1.58579 10.2523 1.25 10.6665 1.25H13.9998C14.4141 1.25 14.7498 1.58579 14.7498 2V5.33333C14.7498 5.74755 14.4141 6.08333 13.9998 6.08333C13.5856 6.08333 13.2498 5.74755 13.2498 5.33333V2.75H10.6665C10.2523 2.75 9.9165 2.41421 9.9165 2Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5305 1.46967C14.8234 1.76256 14.8234 2.23744 14.5305 2.53033L9.86383 7.197C9.57093 7.48989 9.09606 7.48989 8.80317 7.197C8.51027 6.9041 8.51027 6.42923 8.80317 6.13634L13.4698 1.46967C13.7627 1.17678 14.2376 1.17678 14.5305 1.46967Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 4.08325C3.01088 4.08325 2.75 4.34413 2.75 4.66659V12.6666C2.75 12.989 3.01088 13.2499 3.33333 13.2499H11.3333C11.6558 13.2499 11.9167 12.989 11.9167 12.6666V9.33325C11.9167 8.91904 12.2525 8.58325 12.6667 8.58325C13.0809 8.58325 13.4167 8.91904 13.4167 9.33325V12.6666C13.4167 13.8175 12.4842 14.7499 11.3333 14.7499H3.33333C2.18245 14.7499 1.25 13.8175 1.25 12.6666V4.66659C1.25 3.51571 2.18245 2.58325 3.33333 2.58325H6.66667C7.08088 2.58325 7.41667 2.91904 7.41667 3.33325C7.41667 3.74747 7.08088 4.08325 6.66667 4.08325H3.33333Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowOutOfSquare);
export default __webpack_public_path__ + "static/media/icon-arrow-out-of-square.400b5970fa488f1d07dcb7c66bdff0d7.svg";
export { ForwardRef as ReactComponent };